// eslint-disable-next-line
import * as signalR from "@microsoft/signalr";
import { isSeller } from "../common/common";
const URL = `${process.env.REACT_APP_CHAT_API_URL}/chatHub`;
class Connector {
  private connection: signalR.HubConnection;
  public onMessageReceived: any;
  static instance: Connector;
  constructor(roomName: string, callback?: any, entitycodenum?: any) {
    this.connection = new signalR.HubConnectionBuilder().withUrl(URL).withAutomaticReconnect().build(); //.configureLogging("None")
    const start = () => {
      this.connection
        .start()
        .then(() => {
          this.connection
            .send("JoinRoom", roomName, entitycodenum, isSeller() ? 2 : 1)
            .then(() => {
              if (callback) {
                callback();
              }
            })
            .catch((err) => {});
        })
        .catch((err) => {
          setTimeout(() => {
            start();
          }, 5000);
        });
    };

    this.connection.on("ReceiveMessage", (username, message) => {
      this.onMessageReceived(username, message);
    });

    this.connection.onclose(() => {
      start();
    });
    start();
  }
  public newMessage = (messages: string, userName: string, id: string) => {
    this.connection
      .send("SendMessage", userName, messages, id)
      .then(() => {})
      .catch(() => {});
  };
  public static getInstance(roomName: string, callback?: any, entitycodenum?: string): Connector {
    if (!Connector.instance || roomName === "groupConnections") Connector.instance = new Connector(roomName, callback, entitycodenum);
    return Connector.instance;
  }
}
export default Connector.getInstance;
